export default __webpack_public_path__ + "static/media/apila-logo-large.cb585cc0.svg";